import { render, staticRenderFns } from "./DataQuality.vue?vue&type=template&id=e71372d4&scoped=true&"
import script from "./DataQuality.vue?vue&type=script&lang=js&"
export * from "./DataQuality.vue?vue&type=script&lang=js&"
import style0 from "./DataQuality.vue?vue&type=style&index=0&id=e71372d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71372d4",
  null
  
)

export default component.exports